import gql from 'graphql-tag';

const innerFormElement = gql`
  fragment FormElements on FormElement {
    id
    attrid
    label
    options {
      id
      label
      value
      parent
    }
    component
    type
    dynamic
    defaultvalue
    is_editable
    parent
    prefix
    child
    initialOpen
    validation {
      required
      pattern {
        value
        message
      }
      min {
        value
        message
      }
      max {
        value
        message
      }
      minLength {
        value
        message
      }
      maxLength {
        value
        message
      }
    }
  }
`;

const outerSection = gql`
  fragment OuterSection on Section {
    heading
    fragments {
      ...FormElements
      section {
        heading
        fragments {
          ...FormElements
        }
      }
    }
  }
  ${innerFormElement}
`;

export const papStructure = gql`
  query GetPostAdStructure($input: CategoryName, $ad_id: ID) {
    postadform(input: $input, ad_id: $ad_id) {
      title
      meta {
        title
        description
      }
      catkey
      sections {
        ...OuterSection
      }
    }
  }
  ${outerSection}
`;

export const postAd = gql`
  mutation PostQuikrAd($input: QPostAdInput!) {
    doPostAd(input: $input) {
      ad_id
    }
  }
`;
export const editAd = gql`
  mutation EditQuikrAd($ad_id:ID, $data: QPostAdInput!) {
    doEditAd(ad_id: $ad_id, data: $data) {
      ad_id
    }
  }
`;
